import React from 'react';
import {
    Typography,
} from '@mui/material';
const NotFound = () => {
    return (
        <Typography>
            Erreur 404, page non trouvé :/
        </Typography>
    )
}

export default NotFound;